(function () {
  'use strict';

  function initBestSellers(root) {
    var wrap = root.querySelector('.best-sellers__slider-wrap');
    var list = root.querySelector('.best-sellers__list');
    var prevBtn = root.querySelector('.best-sellers__arrow--prev');
    var nextBtn = root.querySelector('.best-sellers__arrow--next');

    if (!wrap || !list) return;

    function isSliderActive() {
      var isDesktop = window.matchMedia('(min-width: 990px)').matches;
      var layout = isDesktop
        ? wrap.getAttribute('data-desktop-layout')
        : wrap.getAttribute('data-mobile-layout');
      return layout === 'slider';
    }

    function getStep() {
      var firstSlide = list.querySelector('.best-sellers__slide');
      if (!firstSlide) return 0;
      var slideWidth = firstSlide.getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(list).gap) || 0;
      return slideWidth + gap;
    }

    function updateArrowVisibility() {
      if (!prevBtn || !nextBtn) return;

      if (!isSliderActive()) {
        prevBtn.classList.add('is-hidden');
        nextBtn.classList.add('is-hidden');
        return;
      }

      var maxScroll = list.scrollWidth - list.clientWidth;

      if (maxScroll <= 4) {
        prevBtn.classList.add('is-hidden');
        nextBtn.classList.add('is-hidden');
        return;
      }

      prevBtn.classList.remove('is-hidden');
      nextBtn.classList.remove('is-hidden');

      prevBtn.disabled = list.scrollLeft <= 4;
      nextBtn.disabled = list.scrollLeft >= maxScroll - 4;
    }

    function scrollByStep(direction) {
      var step = getStep();
      list.scrollBy({ left: step * direction, behavior: 'smooth' });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollByStep(-1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollByStep(1);
      });
    }

    list.addEventListener('scroll', updateArrowVisibility, { passive: true });
    window.addEventListener('resize', updateArrowVisibility);

    updateArrowVisibility();

    // Color swatch -> swap card main image
    var swatches = root.querySelectorAll('.bs-swatch');
    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        var card = swatch.closest('.bs-card');
        if (!card) return;

        var image = card.querySelector('[data-main-image]');
        var newSrc = swatch.getAttribute('data-image');

        if (image && newSrc) {
          image.src = newSrc;
        }

        var siblingSwatches = swatch.parentElement.querySelectorAll('.bs-swatch');
        siblingSwatches.forEach(function (s) {
          s.classList.remove('is-active');
        });
        swatch.classList.add('is-active');
      });
    });
  }

  function initAll() {
    var sections = document.querySelectorAll('.best-sellers');
    sections.forEach(initBestSellers);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.best-sellers');
    if (section) initBestSellers(section);
  });
})();

document.addEventListener('DOMContentLoaded', function () {
  initBestSellerSwatches();
});

function initBestSellerSwatches() {
  const sections = document.querySelectorAll('.best-sellers');

  sections.forEach(function (section) {
    const swatches = section.querySelectorAll('[data-swatch]');

    swatches.forEach(function (swatch) {
      swatch.addEventListener('click', function (event) {
        event.preventDefault();

        const card = swatch.closest('.bs-card');

        if (!card) return;

        const variantId = swatch.dataset.variantId;
        const imageUrl = swatch.dataset.image;
        const variantUrl = swatch.dataset.variantUrl;

        if (!variantId) return;

        /* -----------------------------------------
           1. Change active swatch
        ----------------------------------------- */

        const cardSwatches = card.querySelectorAll('[data-swatch]');

        cardSwatches.forEach(function (item) {
          item.classList.remove('is-active');
        });

        swatch.classList.add('is-active');


        /* -----------------------------------------
           2. Change product image
        ----------------------------------------- */

        if (imageUrl) {
          const image = card.querySelector('[data-main-image]');

          if (image) {
            image.src = imageUrl;

            image.removeAttribute('srcset');

            image.style.opacity = '0.5';

            requestAnimationFrame(function () {
              image.style.transition = 'opacity 0.2s ease';

              requestAnimationFrame(function () {
                image.style.opacity = '1';
              });
            });
          }
        }


        /* -----------------------------------------
           3. Change variant ID used by Add to Cart
        ----------------------------------------- */

        const variantInput = card.querySelector('[data-variant-input]');

        if (variantInput) {
          variantInput.value = variantId;
        }


        /* -----------------------------------------
           4. Update Quick View product URL
        ----------------------------------------- */

        const quickViewButton = card.querySelector(
          '[data-product-url]'
        );

        if (quickViewButton && variantUrl) {
          quickViewButton.dataset.productUrl = variantUrl;
        }


        /* -----------------------------------------
           5. Update product links
        ----------------------------------------- */

        const productLinks = card.querySelectorAll(
          'a[href*="/products/"]'
        );

        productLinks.forEach(function (link) {
          if (!variantUrl) return;

          try {
            const url = new URL(
              variantUrl,
              window.location.origin
            );

            link.href = url.pathname + url.search;
          } catch (error) {
            console.warn(
              'Could not update product link:',
              error
            );
          }
        });


        /* -----------------------------------------
           6. Update selected color text if present
        ----------------------------------------- */

        const selectedColor = card.querySelector(
          '[data-selected-color]'
        );

        if (selectedColor && swatch.dataset.variantTitle) {
          selectedColor.textContent =
            swatch.dataset.variantTitle;
        }
      });
    });
  });
}


/*
 * Shopify Theme Editor support
 */
document.addEventListener(
  'shopify:section:load',
  function (event) {
    if (
      event.target &&
      event.target.classList &&
      event.target.classList.contains('best-sellers')
    ) {
      initBestSellerSwatches();
    }
  }
);